import React from "react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";

const Preview = inject("commonStore")(
  observer((props) => {
    return (
      <Box className="box preview">
        <h1>모바일 미리보기</h1>
        <div
          className="mobile_box ql-editor"
          data-gramm="false"
          dangerouslySetInnerHTML={{ __html: props.contValue }}
          contentEditable={false}
        ></div>
        <div className="todo">
          <span>할 일 목록</span>
          <span
            className="max_length"
            style={
              props.count.length > 1500 ? { color: "green" } : { color: "red" }
            }
            hidden={props.count.length === 0 ? true : false}
          >
            {props.count.length} / 1500 <span>글자</span>
          </span>
          <div className="bar">
            <div style={{ width: `${props.commonStore.goal}%` }}></div>
          </div>
          {props.commonStore.todo.map((v) => {
            return (
              <div key={v.id} className="todos">
                <span>•</span>
                <span
                  style={v.onOff ? { color: "black" } : { color: "#a8aaa8" }}
                >
                  {v.cont}
                </span>
                {v.onOff && (
                  <img
                    src={require("../../styles/img/check.png")}
                    alt="check"
                  />
                )}
              </div>
            );
          })}
        </div>
      </Box>
    );
  })
);

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  > h1 {
    margin-top: 10px;
    font-weight: bold;
    font-size: 20px;
  }

  > .mobile_box {
    margin-top: 20px !important;
    border: 1px solid #e4e4e4;
    width: 375px;
    height: 500px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 15px;
    resize: none;
    overflow-y: auto;

    h2  {
      font-size: 1.5em;
    }

    h3  {
      font-size: 1.17em;
    }

    h4  {
      font-size: 1em;
    }

    img {
      width: 100%;
    }
  }

  > .todo {
    width: 100%;
    margin-top: 1.5vh;

    > span:first-child {
      font: 700 18px "Noto Sans KR";
      color: #43425d;
      margin-right: 10px;
    }

    > .max_length {
      font: 15px "Roboto";
      > span {
        color: #a8aaa8;
        font-size: 10px;
      }
    }

    > .bar {
      width: 100%;
      overflow-x: hidden;
      height: 6px;
      background: linear-gradient(0deg, #e8e8e8, #e8e8e8), #e8e8e8;
      margin-top: 1vh;
      margin-bottom: 1vh;

      > div {
        background: linear-gradient(0deg, #7ac61a, #7ac61a), #e8e8e8;
        height: 100%;
      }
    }

    > .todos {
      line-height: 1.2;
      > span {
        margin-right: 5px;
      }

      > span:first-child {
        color: #f43419;
      }
      > span:nth-child(2) {
        font-size: 12px;
      }

      > img {
        width: 12px;
      }
    }
  }
`;

export default Preview;
